import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { AdminService } from "../../services/admin.service"
import SideModal from "../UI/SideModal/SideModal";

interface IAddSubject {
    setShow: any
    show: boolean
}

export default function AddSubject(props: IAddSubject) {

    const [subject, setSubject] = useState<any>();


    const saveSubject = async () => {
        await AdminService.addSubject(subject).then(res => {
            if (res.status === 200) {
                toast.success("Saved")
                props.setShow(false)
            }
        }).catch(e=>{
            console.error(e)
            toast.error(e.response.data)
        });
    }
    return (
        <>
            <SideModal
                show={props.show}
                handleClose={() => props.setShow(false)}
                body={<>
                    <Form.Group>
                        <Form.Label className="ds-label">Subject Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter subject name"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                    </Form.Group>
                </>
                }

                title="Add Subject"
                footer={<div className="ds-drawer-actions">
                    <button className="ds-btn ds-btn-secondary" onClick={() => props.setShow(false)}>Cancel</button>
                    <button className="ds-btn ds-btn-primary" onClick={saveSubject}>Add Subject</button>
                </div>}
            />
        </>
    )
}